

























































import { IWorkflowFormSection } from '@/models';
import Vue, { PropType } from 'vue';
import WorkflowFormBuilderTemplateFields from './WorkflowFormBuilderTemplateFields.vue';
export default Vue.extend({
  components: { WorkflowFormBuilderTemplateFields },

  props: {
    section: Object as PropType<IWorkflowFormSection>,
    canRemove: Boolean,
    loading: Boolean,
    disabled: Boolean
  },

  methods: {
    openDrawer(fieldIndex?: number) {
      this.$emit('openDrawer', fieldIndex);
    },

    openFieldTypeDrawer(parentFieldId?: number) {
      this.$emit('openFieldTypeDrawer', parentFieldId);
    },

    addSection() {
      this.$emit('addSection');
    },

    removeSection() {
      this.$emit('removeSection');
    },

    save() {
      this.$emit('save');
    }
  }
});
